var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartlineicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.5,339.8c2.1,2.1,5.4,2.1,7.5,0l92.2-91.7l85.1,85.6 c2.1,2.1,5.5,2.1,7.5,0l183.6-183.5c2.1-2.1,2.1-5.5,0-7.5l-26.4-26.4c-2.1-2.1-5.4-2.1-7.5,0L307.2,269.5L222.3,184 c-2.1-2.1-5.4-2.1-7.5,0L92.2,305.8c-2.1,2.1-2.1,5.4,0,7.5L118.5,339.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartlineicon);
export default __webpack_public_path__ + "static/media/chartlineicon.c4e0ad0d358c283543af795fdd82d620.svg";
export { ForwardRef as ReactComponent };